(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  // Cookie preferences link (Footer - Legal)
  // Supports multiple Shopify implementations across themes:
  // 1) window.privacyBanner.showPreferences() (common)
  // 2) window.Shopify.privacyBanner.showPreferences()
  // 3) window.Shopify.customerPrivacy.showPreferences()
  // If none exist yet, tries loading Shopify's consent-tracking-api and retries.
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.js-cookie-preferences');
    if (!link) return;

    e.preventDefault();

    const openPrefs = () => {
      // Most common: Shopify storefront cookie banner runtime
      if (window.privacyBanner?.showPreferences) {
        window.privacyBanner.showPreferences();
        return true;
      }

      // Some themes attach it under Shopify namespace
      if (window.Shopify?.privacyBanner?.showPreferences) {
        window.Shopify.privacyBanner.showPreferences();
        return true;
      }

      // Consent Tracking API variant
      const cp = window.Shopify?.customerPrivacy || window.Shopify?.CustomerPrivacy;
      if (cp?.showPreferences) {
        cp.showPreferences();
        return true;
      }

      // Optional fallback: show banner if preferences modal isn't available
      if (cp?.showBanner) {
        cp.showBanner();
        return true;
      }

      return false;
    };

    // Try immediately
    if (openPrefs()) return;

    // If not available, attempt to load Shopify's consent tracking feature then retry
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (error) {
            console.warn('Failed to load consent-tracking-api', error);
            return;
          }
          openPrefs();
        }
      );
      return;
    }

    console.warn('Cookie preferences API not available (privacyBanner/customerPrivacy not found).');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });


    const grandchildNav = document.querySelectorAll('.grandchild-nav__item.main-nav__item')
     grandchildNav.forEach(item => {
      item.addEventListener('mouseover', () => {
      item.closest('ul').querySelector('.grandchild-nav__item.main-nav__item').classList.remove('is-active')
        item.classList.add('is-active')
     })
    item.addEventListener('mouseout', () => {
      item.classList.remove('is-active')
    })
  })

  const childNav = document.querySelectorAll('.child-nav__item--toggle.main-nav__item--toggle')
  childNav.forEach(el => {
   const navMenu = el.closest('nav-menu')
    el.addEventListener('mouseover', () => {
    navMenu.querySelector('.grandchild-nav__item.main-nav__item')?.classList.add('is-active')
    });
    })

  document.querySelectorAll('main-nav__item-content').forEach(nav => {
    nav.addEventListener('mouseover', () => {
      nav.querySelector('.grandchild-nav__item.main-nav__item')?.classList.add('is-active')
      })
    })


  } catch(e) { console.error(e); }
})();
})();
